import { findAll } from "highlight-words-core";

export default function highlight(textToHighlight: string, searchWord: string): string {
    searchWord = searchWord.trim();
    if (!searchWord)
        return textToHighlight;
    if (!textToHighlight)
        return "";

    const chunks = findAll({
        searchWords: [searchWord],
        textToHighlight,
        caseSensitive: false,
    });

    const highlightedText = chunks
        .map(chunk => {
            const { end, highlight, start } = chunk;
            
            const text = textToHighlight.substr(start, end - start);
            if (highlight) {
                return `<mark>${text}</mark>`;
            } else {
                return text;
            }
        })
        .join("");

    return highlightedText;
}